import PropTypes from "prop-types";
// @polaris
import { Modal, Text } from "@shopify/polaris";

ConfirmDialogPolaris.propTypes = {
  title: PropTypes.node,
  content: PropTypes.node,
  open: PropTypes.bool,
  actions: PropTypes.object,
  onClose: PropTypes.func,
};

export default function ConfirmDialogPolaris({ title, content, actions, open, onClose }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      primaryAction={
        actions?.primary && {
          content: actions?.primary?.content || "Confirm",
          onAction: actions?.primary?.onAction,
          tone: actions?.primary?.tone,
        }
      }
      secondaryActions={
        actions?.secondary
          ? [
              {
                content: actions.secondary.content || "Cancel",
                onAction: actions.secondary.onAction,
              },
            ]
          : undefined
      }
    >
      {content && (
        <Modal.Section>{typeof content === "string" ? <Text variant="bodyMd">{content}</Text> : content}</Modal.Section>
      )}
    </Modal>
  );
}
